import * as Yup from "yup";
import { FinancialSettingsPixKeyType } from "@/models/financialSettings.model";

export const financialSettingsValidationSchema = (document?: string, isSeller?: boolean) =>
  Yup.object().shape({
    bank: Yup.string().when("pixKeyType", (pixKeyType, schema) => {
      const value = Array.isArray(pixKeyType) ? pixKeyType[0] : pixKeyType;
      return value === FinancialSettingsPixKeyType.BANK_ACCOUNT
        ? schema.required("Banco é obrigatório")
        : schema.notRequired();
    }),
    commissionEmails: Yup.array()
      .of(
        Yup.string()
          .required("E-mail é obrigatório")
          .min(1, "E-mail não pode estar vazio")
          .email("E-mail inválido")
      )
      .min(1, "Pelo menos um e-mail de comissão é obrigatório")
      .test("no-empty-emails", "Remova campos de e-mail vazios", (emails) => {
        return emails
          ? emails.every((email) => email && email.trim().length > 0)
          : false;
      }),
    commission: Yup.number()
      .min(0, "Comissão não pode ser negativa")
      .max(100, "Comissão não pode ser maior que 100")
      .required("Comissão é obrigatória"),
    sourceIncomeTax: Yup.number()
      .min(0, "Valor mínimo é 0")
      .max(100, "Valor máximo é 100"),
    pixKeyType: Yup.string()
      .oneOf(Object.values(FinancialSettingsPixKeyType))
      .required("Tipo de chave Pix é obrigatório"),
    // commissionModeId: Yup.string()
    //   .required("Modelo de Comissão é obrigatório")
    //   .test("not-empty", "Modelo de Comissão é obrigatório", (value) => {
    //     return value !== undefined && value !== null && value.trim().length > 0;
    //   }),
    pixKey: Yup.string().when("pixKeyType", (pixKeyType, schema) => {
      const value = Array.isArray(pixKeyType) ? pixKeyType[0] : pixKeyType;

      // CPF para sellers não tem restrições
      if (value === FinancialSettingsPixKeyType.CPF && isSeller) {
        return schema.required("Chave Pix é obrigatória");
      }


      if (value === FinancialSettingsPixKeyType.DOCUMENT) {
        // Para sellers, não há restrição de correspondência do CNPJ
        if (isSeller) {
          return schema.required("Chave Pix é obrigatória");
        }
        if (!document) {
          return schema.test(
            "document-required",
            "CNPJ do cadastro não foi informado. Não é possível usar CNPJ como chave PIX.",
            () => {
              return false;
            }
          );
        }

        return schema
          .required("Chave Pix é obrigatória")
          .test(
            "cnpj-match",
            "O CNPJ informado no PIX deve ser igual ao CNPJ do cadastro",
            (val) => {
              if (!val || !document) {
                return false;
              }

              const isValid = val === document;

              return isValid;
            }
          );
      }

      return value !== FinancialSettingsPixKeyType.BANK_ACCOUNT
        ? schema
          .required("Chave Pix é obrigatória")
          .min(1, "Chave Pix não pode estar vazia")
          .test("not-empty", "Chave Pix não pode estar vazia", (val) => {
            return val ? val.trim().length > 0 : false;
          })
        : schema.notRequired();
    }),
    agency: Yup.string().when("pixKeyType", (pixKeyType, schema) => {
      const value = Array.isArray(pixKeyType) ? pixKeyType[0] : pixKeyType;
      return value === FinancialSettingsPixKeyType.BANK_ACCOUNT
        ? schema.required("Agência bancária é obrigatória")
        : schema.notRequired();
    }),
    bankAccount: Yup.string().when("pixKeyType", (pixKeyType, schema) => {
      const value = Array.isArray(pixKeyType) ? pixKeyType[0] : pixKeyType;
      return value === FinancialSettingsPixKeyType.BANK_ACCOUNT
        ? schema.required("Conta bancária é obrigatória")
        : schema.notRequired();
    }),
    accountDigit: Yup.string().when("pixKeyType", (pixKeyType, schema) => {
      const value = Array.isArray(pixKeyType) ? pixKeyType[0] : pixKeyType;
      return value === FinancialSettingsPixKeyType.BANK_ACCOUNT
        ? schema.required("Dígito da conta é obrigatório")
        : schema.notRequired();
    }),
  });
